var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhotoLibrary = function SvgPhotoLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#202020",
    d: "M53.333 10.667v32h-32v-32zm0-5.333h-32C18.4 5.334 16 7.734 16 10.667v32c0 2.934 2.4 5.334 5.333 5.334h32c2.933 0 5.333-2.4 5.333-5.334v-32c0-2.933-2.4-5.333-5.333-5.333M30.666 31.121l4.507 6.026 6.613-8.266L50.666 40H24zM5.333 16v37.333c0 2.933 2.4 5.333 5.333 5.333H48v-5.333H10.666V16.001z"
  })));
};
export default SvgPhotoLibrary;